<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>网站配置</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/config/custom">自定义配置</el-breadcrumb-item>
        <el-breadcrumb-item>配置列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>自定义配置列表</span>
        </div>
        <el-button @click="dialogFormVisible = true" size="small" icon="el-icon-plus" type="primary">添加配置</el-button>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <el-select v-model="search.cat" placeholder="请选择分类">
              <el-option label="设备类型" value="dev_type"></el-option>
              <el-option label="软件类型" value="soft_type"></el-option>
              <el-option label="车辆品牌" value="car_brand"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column prop="title" label="类型" width="120"></el-table-column>
          <el-table-column prop="zh_name" label="名称" width="160"></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column prop="sort" label="排序" width="80"></el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="自定义属性" width="30%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="选择分类" :label-width="formLabelWidth" prop="title">
          <el-select v-model="ruleForm.title" placeholder="请选择分类">
            <el-option label="设备类型" value="dev_type"></el-option>
            <el-option label="软件类型" value="soft_type"></el-option>
            <el-option label="车辆品牌" value="car_brand"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称(中文)" :label-width="formLabelWidth" prop="zh_name">
          <el-input v-model="ruleForm.zh_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类排序" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      dialogFormVisible: false,
      ruleForm: {
        title: "",
        zh_name: "",
        en_name: "",
        ja_name: "",
        ko_name: "",
        sort: "",
      },
      search: {
        keys: "",
        cat: "",
      },
      rules: {
        title: [{ required: true, message: "请选择分类", trigger: "change" }],
        zh_name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      formLabelWidth: "120px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.cat = "";
      this.getList();
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/custom/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/custom/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.cat = that.search.cat;
      that.axios.post("/custom/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/custom/store";
        if (that.id) {
          formData.id = that.id;
          url = "/custom/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.ruleForm.title = "";
          that.ruleForm.zh_name = "";
          that.ruleForm.en_name = "";
          that.ruleForm.sort = "";
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>